var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mapActions } from 'vuex';
import { Const } from './provider/candle-history/lib/const.cls';
import * as moment from 'moment';
import * as Types from '../../types';
import { gini } from './lib/gini.cls';
import * as giniStoreExtensions from './provider/candle-history';
var state = __assign({}, giniStoreExtensions.stateExt);
var actions = __assign({}, giniStoreExtensions.actionsExt);
var mutations = __assign({}, giniStoreExtensions.mutationsExt);
var getters = __assign({}, giniStoreExtensions.gettersExt);
var giniStore = {
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
};
var _store;
var intervalValue = null;
export var giniMixins = {
    created: function () {
        var _store = this.$store;
        if (!(_store && _store.state && _store.state[gini.STORE_MODULE_NAME])) {
            try {
                this.$store.registerModule(gini.STORE_MODULE_NAME, giniStore);
            }
            catch (error) { }
        }
    },
    methods: __assign(__assign({}, mapActions({
        _rungetRegisterDiseaseList: Const.RUN_REGISTER_DISEASE_LIST,
        //prescription
        _runGetPatientPrescriptionList: Const.RUN_GET_PATIENT_PRESCRIPTION_LIST,
        _runGetPatientPrescriptionDetail: Const.RUN_GET_PATIENT_PRESCRIPTION_DETAIL,
        _runpatientAddEditPrescription: Const.RUN_PATIENT_ADDEDIT_PRESCRIPTION,
        //test-report
        _runGetPatientTestReportList: Const.RUN_GET_PATIENT_TEST_REPORT_LIST,
        _runGetPatientTestReportDetail: Const.RUN_GET_PATIENT_TEST_REPORT_DETAIL,
        _runUploadPatientTestReport: Const.RUN_UPLOAD_PATIENT_TEST_REPORT,
        _runeditPatientTestReport: Const.RUN_EDIT_PATIENT_TEST_REPORT,
        //appointment
        _runGetAppointmentList: Const.RUN_GET_APPOINTMENT_LIST,
        _runGetAppointmentDetail: Const.RUN_GET_APPOINTMENT_DETAIL,
        _runGetAppointmentInfo: Const.RUN_GET_APPOINTMENT_INFO,
        _runAddAppointment: Const.RUN_ADD_APPOINTMENT,
        _runGetAvailableSlotsList: Const.RUN_GET_AVAILABLE_SLOTS_LIST,
        _runGetBusySlotList: Const.RUN_GET_BUSY_SLOT_LIST,
        _runGetPatientBusySlot: Const.RUN_GET_PATIENT_BUSY_SLOT,
        _runGetDoctorDetails: Const.RUN_GET_DOCTOR_DETAI,
        //obt call
        _runBookObtCall: Const.RUN_BOOK_OBT_CALL,
        _runCheckObtCall: Const.RUN_CHECK_OBT_CALL,
        //notification
        _runGetNotificationList: Const.RUN_GET_NOTIFICATION_LIST,
        _runGetInitialData: Const.RUN_GET_INITIAL_DATA,
        _runAddFoodIntake: Const.RUN_ADD_FOOD_INTAKE,
        _runAddWeight: Const.RUN_ADD_WEIGHT,
        _runAddBloodPressure: Const.RUN_ADD_BLOOD_PRESSURE,
        _runAddGlucoseData: Const.RUN_ADD_GLUCOSE_DATA,
        _runAddEmotionData: Const.RUN_ADD_EMOTION_DATA,
        _runAddDigestionData: Const.RUN_ADD_DIGESTION_DATA,
        _runAddSleepData: Const.RUN_ADD_SLEEP_DATA,
        _runGetChartData: Const.RUN_GET_CHART_DATA,
        _runGetMedicineList: Const.RUN_GET_MEDICINE_LIST,
        _runGetTaskActionList: Const.RUN_GET_TASK_ACTION_LIST,
        _runEditProfile: Const.RUN_EDIT_PROFILE,
        _runEditProfilePic: Const.RUN_EDIT_PROFILE_PIC
    })), { stepPageOpenFunc: function (getStep) {
            var step = '/step' + (parseInt(this.get_user.step) + 1);
            return step;
        },
        pageName: function (val) {
            this.$parent.pageTxt = val;
        },
        computedCommonFunc: function (getFuncName) {
            try {
                return this.$store.getters[getFuncName];
            }
            catch (ex) {
                return [];
            }
        },
        formatDate: function (date, time) {
            if (time) {
                return moment(date).format('Do MMM YYYY hh:mm a');
            }
            else {
                return moment(date).utc().format('Do MMM YYYY');
            }
        },
        getWeightLabel: function (val) {
            var unit = this.weightOptions.find(function (i) { return i.value == val.unit; });
            if (unit)
                return val.weight + " " + unit.alias;
            return val.weight + " kg";
        },
        getMoodLabel: function (val) {
            var mood = this.moodOptions.find(function (i) { return i.value == val; });
            if (mood)
                return mood.label;
            return 'Happy';
        },
        sleepTimeInHours: function (time) {
            return Number(moment.utc(moment.duration(time, "minutes").asMilliseconds()).format("H.mm"));
        },
        redirection: function (getPageName, getParameters) {
            var inputJson = {
                name: getPageName,
                query: getParameters
            };
            this.$router.push(inputJson);
        },
        formatEditdata: function (getdata, sourcetype) {
            if (Object.keys(getdata).length > 0) {
                var jsondata = {};
                if (sourcetype == 'Lal path labs') {
                    for (var key in getdata) {
                        var count = (getdata[key].match(/\,/g) || []).length;
                        if (count == 0 || count >= 2) {
                            jsondata[key] = {
                                value: getdata[key].split(',')[0].trim(),
                                unit: ((getdata[key].split(',')[1]) ? getdata[key].split(',')[1] : ''),
                                range: ((getdata[key].split(',')[2]) ? getdata[key].split(',')[2].trim() : '-')
                            };
                        }
                        else if (count == 1) {
                            jsondata[key] = {
                                value: getdata[key].split(',')[0].trim(),
                                unit: '',
                                range: ((getdata[key].split(',')[1]) ? getdata[key].split(',')[1].trim() : '-')
                            };
                        }
                    }
                }
                else if (sourcetype == 'Thyrocare' || sourcetype == 'Nueclear') {
                    for (var key in getdata) {
                        if (getdata[key].includes('Reference Range')) {
                            jsondata[key] = {
                                value: getdata[key].split(',')[3].trim(),
                                unit: ((getdata[key].split(',')[4]) ? getdata[key].split(',')[4].trim() : ''),
                                technology: getdata[key].split(',')[2].trim(),
                                range: '-',
                            };
                        }
                        else {
                            var splidata = getdata[key].split(',');
                            jsondata[key] = {
                                value: ((splidata[1]) ? splidata[1].trim() : ''),
                                unit: ((splidata[2]) ? splidata[2].trim() : ''),
                                range: ((splidata[3]) ? splidata[3].trim() : '-'),
                                technology: (splidata[0] ? splidata[0].trim() : '-')
                            };
                        }
                    }
                }
                else if (sourcetype == 'Srl') {
                    for (var key in getdata) {
                        jsondata[key] = {
                            value: getdata[key].split(',')[0].trim(),
                            unit: ((getdata[key].split(',')[2]) ? getdata[key].split(',')[2].trim() : ''),
                            range: ((getdata[key].split(',')[1]) ? getdata[key].split(',')[1].trim() : '-')
                        };
                    }
                }
                else if (sourcetype == 'Healthians' || sourcetype == 'Gurmeen') {
                    for (var key in getdata) {
                        jsondata[key] = {
                            value: getdata[key].split(',')[0].trim(),
                            unit: ((getdata[key].split(',')[1]) ? getdata[key].split(',')[1].trim() : ''),
                            range: ((getdata[key].split(',')[2]) ? getdata[key].split(',')[2].trim() : '-')
                        };
                    }
                }
                return jsondata;
            }
        } }),
    computed: {
        taskActionList: function () { return this.computedCommonFunc(Const.GET_TASK_ACTION_LIST); },
        medicineList: function () { return this.computedCommonFunc(Const.GET_MEDICINE_LIST); },
        get_user: function () { return this.computedCommonFunc(Types.GET_USER); },
        diseaseList: function () { return this.computedCommonFunc(Const.GET_REGISTER_DISEASE_LIST); },
        //prescription
        prescriptionList: function () { return this.computedCommonFunc(Const.GET_PATIENT_PRESCRIPTION_LIST); },
        prescriptionView: function () { return this.computedCommonFunc(Const.GET_PATIENT_PRESCRIPTION_DETAIL); },
        //test-report
        testReportList: function () { return this.computedCommonFunc(Const.GET_PATIENT_TEST_REPORT_LIST); },
        testReportDetail: function () { return this.computedCommonFunc(Const.GET_PATIENT_TEST_REPORT_DETAIL); },
        //appointment
        appointmentList: function () { return this.computedCommonFunc(Const.GET_APPOINTMENT_LIST); },
        appointmentDetail: function () { return this.computedCommonFunc(Const.GET_APPOINTMENT_DETAIL); },
        appointmentInfo: function () { return this.computedCommonFunc(Const.GET_APPOINTMENT_INFO); },
        totalSlotList: function () { return this.computedCommonFunc(Const.GET_AVAILABLE_SLOTS_LIST); },
        busySlotList: function () { return this.computedCommonFunc(Const.GET_BUSY_SLOT_LIST); },
        patientBusySlot: function () { return this.computedCommonFunc(Const.GET_PATIENT_BUSY_SLOT); },
        //notification
        notificationList: function () { return this.computedCommonFunc(Const.GET_NOTIFICATION_LIST); },
        initialData: function () { return this.computedCommonFunc(Const.GET_INITIAL_DATA); },
        chartData: function () { return this.computedCommonFunc(Const.GET_CHART_DATA); },
        breakfastOptions: function () { return this.computedCommonFunc(Const.BREAKFAST_OPTIONS); },
        weightOptions: function () { return this.computedCommonFunc(Const.WEIGHT_OPTIONS); },
        moodOptions: function () { return this.computedCommonFunc(Const.MOOD_OPTIONS); },
        bowelMovementsOptions: function () { return this.computedCommonFunc(Const.BOWEL_MOVEMENTS_OPTIONS); },
        poopColorOptions: function () { return this.computedCommonFunc(Const.POOP_COLOR_OPTIONS); },
        poopExperienceOptions: function () { return this.computedCommonFunc(Const.POOP_EXPERIENCE_OPTIONS); },
        timeDurationOptions: function () { return this.computedCommonFunc(Const.TIME_DURATION_OPTIONS); },
        pushPressureOptions: function () { return this.computedCommonFunc(Const.PUSH_PRESSURE_OPTIONS); },
        poopComplicationsOptions: function () { return this.computedCommonFunc(Const.POOP_COMPLICATIONS_OPTIONS); },
        checkObtCall: function () { return this.computedCommonFunc(Const.GET_CHECK_OBT_CALL); },
    }
};
export default giniMixins;



//////////////////
// WEBPACK FOOTER
// ./src/plugins/Gini/index.ts
// module id = null
// module chunks = 